import { useDashboardFilter } from '@/hooks';
import { livingConditionAgents } from '@/services';
import { colors } from '@/theme/colors';
import { getDataWithPercentage } from '@/utils/data';
import { DataPercentageComputed } from 'big-data';
import { useEffect, useMemo, useState } from 'react';

export function useViolenceAreaSituationData() {
  const [violenceAreaSituation, setViolenceAreaSituation] = useState<
    DataPercentageComputed[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const { ibge, year, semester, zone } = useDashboardFilter();

  useEffect(() => {
    setLoading(true);
    livingConditionAgents
      .getHouseViolenceSituation(ibge, year, semester, zone)
      .then((data) => getDataWithPercentage(data))
      .then((data) => {
        const coloredData = data.map((d) => {
          let color = '';
          if (d.name === 'Sim') color = colors.red400;
          else if (d.name === 'Não') color = colors.green200;
          else color = colors.yellow500;

          return {
            ...d,
            color
          };
        });
        setViolenceAreaSituation(coloredData);
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [ibge, year, semester, zone]);

  return useMemo(
    () => ({
      violenceAreaSituation,
      loading,
      error
    }),
    [violenceAreaSituation, loading, error]
  );
}
